module.exports = __webpack_public_path__ + "img/export-icon.241cb820.svg";